import React, { useId } from 'react';

export const Logo = ({ size = 'md', showText = true, className = '' }) => {
  const uniqueId = useId();
  const gradientId = `logoGradient-${uniqueId}`;
  const waveGradientId = `waveGradient-${uniqueId}`;
  
  const sizes = {
    sm: { icon: 32, text: 'text-lg' },
    md: { icon: 44, text: 'text-xl' },
    lg: { icon: 56, text: 'text-2xl' },
    xl: { icon: 72, text: 'text-3xl' }
  };
  
  const { icon, text } = sizes[size] || sizes.md;
  
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg 
        width={icon} 
        height={icon} 
        viewBox="0 0 64 64" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0"
      >
        {/* Background Circle with Gradient */}
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#f97316" />
            <stop offset="100%" stopColor="#ea580c" />
          </linearGradient>
          <linearGradient id={waveGradientId} x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#fdba74" />
            <stop offset="100%" stopColor="#fb923c" />
          </linearGradient>
        </defs>
        
        {/* Main Circle */}
        <circle cx="32" cy="32" r="30" fill={`url(#${gradientId})`} />
        
        {/* Microphone Body */}
        <rect x="26" y="16" width="12" height="20" rx="6" fill="white" />
        
        {/* Microphone Stand */}
        <path 
          d="M32 38V44" 
          stroke="white" 
          strokeWidth="3" 
          strokeLinecap="round"
        />
        <path 
          d="M26 44H38" 
          stroke="white" 
          strokeWidth="3" 
          strokeLinecap="round"
        />
        
        {/* Microphone Arc */}
        <path 
          d="M22 28C22 34.627 27.373 40 34 40H30C23.373 40 18 34.627 18 28" 
          stroke="white" 
          strokeWidth="2.5" 
          strokeLinecap="round"
          fill="none"
        />
        
        {/* Sound Waves */}
        <path 
          d="M44 24C46 26 47 29 47 32C47 35 46 38 44 40" 
          stroke={`url(#${waveGradientId})`} 
          strokeWidth="2.5" 
          strokeLinecap="round"
          fill="none"
          opacity="0.9"
        />
        <path 
          d="M48 20C51 24 53 28 53 32C53 36 51 40 48 44" 
          stroke={`url(#${waveGradientId})`} 
          strokeWidth="2.5" 
          strokeLinecap="round"
          fill="none"
          opacity="0.6"
        />
        
        {/* Lightbulb/Idea Accent */}
        <circle cx="50" cy="14" r="8" fill="#fbbf24" />
        <path 
          d="M50 10V14M50 14L48 16M50 14L52 16" 
          stroke="white" 
          strokeWidth="1.5" 
          strokeLinecap="round"
        />
        <circle cx="50" cy="18" r="1.5" fill="white" />
      </svg>
      
      {showText && (
        <div className="flex flex-col">
          <span className={`font-bold ${text} tracking-tight leading-none`}>
            Voice <span className="text-primary">Ideias</span>
          </span>
          <span className="text-[10px] text-muted-foreground tracking-wider uppercase">
            Capture suas ideias
          </span>
        </div>
      )}
    </div>
  );
};

export const LogoIcon = ({ size = 40, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 64 64" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <defs>
      <linearGradient id="logoGradientIcon" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#f97316" />
        <stop offset="100%" stopColor="#ea580c" />
      </linearGradient>
      <linearGradient id="waveGradientIcon" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#fdba74" />
        <stop offset="100%" stopColor="#fb923c" />
      </linearGradient>
    </defs>
    
    <circle cx="32" cy="32" r="30" fill="url(#logoGradientIcon)" />
    
    <rect x="26" y="16" width="12" height="20" rx="6" fill="white" />
    
    <path d="M32 38V44" stroke="white" strokeWidth="3" strokeLinecap="round" />
    <path d="M26 44H38" stroke="white" strokeWidth="3" strokeLinecap="round" />
    
    <path 
      d="M22 28C22 34.627 27.373 40 34 40H30C23.373 40 18 34.627 18 28" 
      stroke="white" 
      strokeWidth="2.5" 
      strokeLinecap="round"
      fill="none"
    />
    
    <path 
      d="M44 24C46 26 47 29 47 32C47 35 46 38 44 40" 
      stroke="url(#waveGradientIcon)" 
      strokeWidth="2.5" 
      strokeLinecap="round"
      fill="none"
      opacity="0.9"
    />
    <path 
      d="M48 20C51 24 53 28 53 32C53 36 51 40 48 44" 
      stroke="url(#waveGradientIcon)" 
      strokeWidth="2.5" 
      strokeLinecap="round"
      fill="none"
      opacity="0.6"
    />
    
    <circle cx="50" cy="14" r="8" fill="#fbbf24" />
    <path 
      d="M50 10V14M50 14L48 16M50 14L52 16" 
      stroke="white" 
      strokeWidth="1.5" 
      strokeLinecap="round"
    />
    <circle cx="50" cy="18" r="1.5" fill="white" />
  </svg>
);

export default Logo;
